module.exports = __webpack_public_path__ + "img/服務條款8.f860ed40.png";